/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentFolders.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Folder API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, November 19, 2018 - 06:07:58 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      11/19/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Folders = {
    all: (parentid) => requests.get(`/Folders?parentid=${parentid}`),
    folderTree: () => requests.get('/FolderTree'),
    getContents: (folderid) => requests.get(`/FolderContents?folderid=${folderid}`),
    get: folderid => requests.get(`/Folder/${folderid}`),
    create: folder => requests.post(`/Folders`, folder),
    update: (folderid, folder) => requests.put(`/Folder/${folderid}`, folder),
    delete: folderid => requests.del(`/Folder/${folderid}`),
};

export const Documents = {
    all: (companyid, userid, folderid) => requests.get(`/Documents?companyid=${companyid}&userid=${userid}&folderid=${folderid}`),
    get: contentid => requests.get(`/Document/${contentid}`),
    create: content => requests.post(`/Documents`, content),
    update: (contentid, content) => requests.put(`/Document/${contentid}`, content),
    delete: contentid => requests.del(`/Document/${contentid}`),
};

export const Files = {
    get: fileid => requests.get(`/File/${fileid}`),
    create: file => requests.post(`/Files`, file),
    update: (fileid, file) => requests.put(`/File/${fileid}`, file),
    delete: fileid => requests.del(`/File/${fileid}`),
};

export const Images = {
    get: imageid => requests.get(`/Image/${imageid}`),
    create: image => requests.post(`/Images`, image),
    update: (imageid, image) => requests.put(`/Image/${imageid}`, image),
    delete: imageid => requests.del(`/Image/${imageid}`),
};